import React, { FC } from 'react';

import styles from './_FavoriteBadge.module.css';

interface FavoriteBadgeProps {
    ariaLabel: string;
}

export const FavoriteBadge: FC<FavoriteBadgeProps> = ({ ariaLabel }) => (
    <div className={styles.root} role="img" aria-label={ariaLabel} />
);
